import React from 'react'
import { checkTranslation, checkVariablesListForValue, textVariableReplacer } from '../../utils/useful';

class ButtonWidget extends React.Component {

  onClick = () => {

    let extra = this.props.extra ? { ...this.props.extra } : {}
    extra.headers = this.props.headers

    // console.log(this.props.header?.information)
    let info = JSON.parse(JSON.stringify(this.props.header?.information)) 

    let paramsList = {}

    // console.log('this.props.fullData', this.props.fullData)
    // console.log('this.props.params', this.props.params)


    if (info.pageParams) {
      for (let i = 0; i < Object.values(info.pageParams).length; i++) {
        const param = Object.values(info.pageParams)[i];
        paramsList[param.name] = JSON.parse(JSON.stringify(param))
        // console.log('paramsList[param.name]', paramsList[param.name])

        if (/\{\{(.*?)\}\}/.test(String(paramsList[param.name].value))) {

          let baseValue = String(paramsList[param.name].value).replace(/{/g, '').replace(/}/g, '')

          paramsList[param.name].value = checkVariablesListForValue(this.props.params, baseValue)?.data//textVariableReplacer(this.props.fullData, paramsList[param.name], this.props.headers, 'Current Record')

        }
        // console.log('paramsList[param.name]', paramsList[param.name])
      }

      info.pageParams = paramsList

    }

    // console.log('paramsList', info)

    // Object.values(info.pageParams).sort((a, b) => a.index - b.index)


    if (this.props.actionClicked) {
      this.props.actionClicked(info, this.props.fullData, extra)
    }

  }

  render() {


    let information = this.props.header?.information
    return (

      <div className="" style={{ minHeight: 5, }}>
        <button style={{ cursor: 'pointer', padding: '5px 10px', background: information.background ?? '#ee5050', color: information.color ?? "#fff", borderRadius: 20 }} onClick={() => this.onClick()}>
          <p>{checkTranslation(information?.label ?? '{{lang}}Button')}</p>
        </button>
      </div>


    )
  }
}

export default ButtonWidget;